import { Typography } from 'antd';
import { Avatar } from 'components/common';
import OmiChanelChatSourceIcon from 'components/omni-channel-chat/OmiChanelChatSourceIcon';
import dayjs from 'dayjs';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { ChatSessionDto } from 'types';

type Props = {
  item: ChatSessionDto;
  onClick?: () => void;
  active?: boolean;
};

const OmniChannelLeadChatOngoingItem: React.FC<Props> = ({ item, onClick, active }) => {
  return (
    <div
      className={twMerge(
        'flex h-18 cursor-pointer items-center gap-3 px-5 py-3 transition-all',
        active ? 'bg-[#F7F8F9] hover:bg-[#F7F8F9] hover:opacity-90' : 'group hover:bg-hoverColor2'
      )}
      onClick={onClick}
    >
      <div className='relative h-[44px] w-[44px]'>
        <Avatar key={item.chatSessionId} size={44} src={item.chat?.customerAvatar} name={item.chat?.customerName} />
        <div className='absolute -bottom-0.5 -right-0.5 flex items-center justify-center'>
          <OmiChanelChatSourceIcon size={20} source={item.chat?.source} />
        </div>
      </div>
      <div className='flex flex-1 items-start justify-between'>
        <div className='flex flex-1 flex-col gap-1'>
          <Typography.Text ellipsis className='font-semibold'>
            {item.chat?.customerName}
          </Typography.Text>
          <div className='flex w-full items-center gap-2'>
            <Avatar
              key={item.assigner?.userId}
              size={18}
              src={item?.assigner?.avatar}
              name={item?.assigner?.fullName}
            />
            <Typography.Text className='text-xs text-colorTextPlaceholder'>{item?.assigner?.fullName}</Typography.Text>
            <Typography.Text className='text-xs text-colorTextPlaceholder'>•</Typography.Text>
            <Typography.Text className='text-xs text-colorTextPlaceholder'>Ext. {item.extensionId}</Typography.Text>
          </div>
        </div>
        <div className='flex max-w-[272px] gap-[2px]'>
          <Typography.Text className='text-xs text-colorTextPlaceholder'>
            Từ {dayjs(item.processingAt).format('HH:mm')}
          </Typography.Text>
        </div>
      </div>
    </div>
  );
};
export default OmniChannelLeadChatOngoingItem;
